import Auth0Lock from 'auth0-lock';
import axios from 'axios';
import { set, get, clear } from 'idb-keyval';

import { isType } from 'utils/core';
import authConfig from './config';
import endpoints from '../endpoints';

const { initializeUserData } = endpoints;
const Lock = new Auth0Lock(
  process.env.REACT_APP_AUTH0_CLIENT,
  process.env.REACT_APP_AUTH0_DOMAIN,
  {
    ...authConfig,
    language: 'pt-BR',
  },
);

export const login = () => {
  Lock.show();
};

export const logout = async () => {
  await clear();
  await Lock.logout({ returnTo: `${window.location.origin}/Login` });
};

export const hide = () => {
  Lock.hide();
};

export const handleLoginRequest = () =>
  new Promise((resolve, reject) => {
    Lock.on('authenticated', authResult => {
      const { idTokenPayload, accessToken, idToken } = authResult;
      Lock.getUserInfo(accessToken, (error, profile) => {
        const { email } = profile;
        if (!error) {
          if (email.includes('@semantix')) {
            axios
              .get(`${initializeUserData}/${email}`)
              .then(response => {
                const expiresAt = idTokenPayload.exp;
                const { data } = response;
                const { input: userData } = data;
                const res = isType(userData, 'string')
                  ? JSON.parse(userData)
                  : userData;
                const user = { ...profile, ...res };
                set('profile', JSON.stringify(user));
                set('accessToken', accessToken);
                set('idToken', idToken);
                set('isAuthenticated', new Date().getTime() > expiresAt);
                hide();
                resolve({
                  profile: JSON.stringify(user),
                  isAuthenticated: new Date().getTime() > expiresAt,
                });
              })
              .catch(err => {
                logout();
                reject(err);
              });
          } else {
            window.location.pathname = '/not-allowed';
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({ message: 'Usuario não pertence a esta organização' });
          }
        } else {
          reject(error);
        }
      });
    });

    Lock.on('unrecoverable_error', error => {
      reject(error);
    });
  });

export const isAuthenticated = async () => {
  const response = await get('isAuthenticated');
  return response;
};

export const getProfile = async () => {
  const profile = await get('profile');
  return profile;
};

export const getIdToken = async () => {
  const idToken = await get('idToken');
  return idToken;
};

export const getAcessToken = async () => {
  const accessToken = await get('accessToken');
  return accessToken;
};
